import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const DateSelectorWrapper = styled.div(() =>
  mq({
    width: '100%',
    marginBottom: [
      defaultTheme.spacing.s,
      defaultTheme.spacing.s,
      defaultTheme.spacing.l,
      defaultTheme.spacing.l,
    ],
  }),
);

export const Wrapper = styled.div(() =>
  mq({
    width: '100%',
    backgroundColor: defaultTheme.background.white,
    padding: [
      defaultTheme.spacing.l,
      defaultTheme.spacing.l,
      '32px 64px',
      '32px 64px',
    ],
    marginBottom: defaultTheme.spacing.s,
  }),
);

export const MonthList = styled.ol(() =>
  mq({
    display: 'grid',
    gridTemplateColumns: 'repeat(1, 1fr)',
    gridGap: defaultTheme.spacing.l,
    width: '100%',
  }),
);

export const MonthWrapper = styled.li(() =>
  mq({
    backgroundColor: defaultTheme.background.white,
    padding: [
      defaultTheme.spacing.l,
      defaultTheme.spacing.l,
      defaultTheme.spacing.l,
      '32px 80px',
    ],
  }),
);

export const Month = styled.p(() =>
  mq({
    fontSize: defaultTheme.font.size.l,
    fontWeight: 'bold',
    borderBottom: `1px solid ${defaultTheme.border.color.darkGray}`,
    paddingBottom: defaultTheme.spacing.s,
  }),
);

export const RaceList = styled.ul(() =>
  mq({
    display: 'grid',
    gridTemplateColumns: ['repeat(1, 1fr)', 'repeat(1, 1fr)', 'repeat(3, 1fr)'],
    gridColumnGap: defaultTheme.spacing.xxl,
  }),
);

export const RaceItem = styled.li(() =>
  mq({
    '&:not(:last-of-type)': {
      borderBottom: [
        `1px solid ${defaultTheme.border.color.mediumLightGray}`,
        `1px solid ${defaultTheme.border.color.mediumLightGray}`,
        'none',
      ],
    },
    '&:not(:nth-of-type(3n+1):nth-last-of-type(-n+3), &:nth-of-type(3n+1):nth-last-of-type(-n+3) ~ li)':
      {
        borderBottom: `1px solid ${defaultTheme.border.color.mediumLightGray}`,
      },
    padding: `${defaultTheme.spacing.l} 0`,
  }),
);

export const HeldDate = styled.time(() =>
  mq({
    color: defaultTheme.text.gray,
    fontSize: defaultTheme.font.size.s,
  }),
);

export const ProgramName = styled.p(() =>
  mq({
    display: 'flex',
    alignItems: 'center',
    minHeight: '26px',
    fontSize: defaultTheme.font.size.m,
    fontWeight: 'bold',
    '& > span': {
      marginLeft: defaultTheme.spacing.s,
    },
  }),
);

export const VelodromeName = styled.p(() =>
  mq({
    fontSize: defaultTheme.font.size.s,
  }),
);

export const EmptyMessage = styled.p(() =>
  mq({
    color: defaultTheme.text.gray,
    fontSize: defaultTheme.font.size.m,
    textAlign: 'center',
    backgroundColor: defaultTheme.background.white,
    padding: '80px 0',
  }),
);
